// extracted by mini-css-extract-plugin
module.exports = {"explanationRow":"styles-module__explanationRow___2Cwiz"};